const MENU_BAR_ROLE = 'menubar';
const CONTEXT_ITEM_TAG = 'WPP-LIST-ITEM';
const TOPBAR_NAVIGATION_ITEM_TAG = 'WPP-NAVIGATION-ITEM';
const MENU_ROLE = 'menu';
const WPP_LIST_CLASSNAME = 'wpp-list';

export { CONTEXT_ITEM_TAG as C, MENU_BAR_ROLE as M, TOPBAR_NAVIGATION_ITEM_TAG as T, WPP_LIST_CLASSNAME as W, MENU_ROLE as a };
